import toastMessage from "../../utils/toastMessage";
import language from "../../language";
import formatDropdownData from "../../utils/formatDropdownData";
import axios from "axios";
import { getStorage } from "../../utils/storage";
import api from "../../utils/api";

export const fetchAccounts = async (lng = "english", params) => {
  const { listType, active = undefined, page, limit } = params || {};
  const { accessToken, sub } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("core")}/accounts`,
      data: null, //force axios send headers content type
      params: {
        userId: sub,
        // active,
        page,
        limit,
      },
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "accountName", "accountId");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_accounts);
  }
};

export const fetchActiveAccounts = async (lng = "english", params) => {
  const { listType, active = undefined, page, limit } = params || {};
  const { accessToken, sub } = await getStorage();
  let headers = {
    "Content-Type": "application/json;charset=UTF-8",
  };

  try {
    if (accessToken) {
      headers.Authorization = "Bearer " + accessToken;
    }

    const options = {
      method: "GET",
      url: `${api("core")}/accounts/active`,
      data: null, //force axios send headers content type
      headers,
    };

    const data = await axios(options);

    if (listType === "dropdown") {
      return formatDropdownData(data.data, "accountName", "accountId");
    }

    return data.data;
  } catch (error) {
    toastMessage("error", language[lng].unable_to_fetch_accounts);
  }
};
